export const format = {

  filters: {
    format: function (value) {
      if (!value) return '0.00'
      return parseFloat(value).toFixed(2)
    },

    empty: function (value) {
      if (value === '' || value === ' ' || !value) return '---'
      return value
    }
  },

  methods: {
    formatDateDisplay (date) {
      return date ? this.moment(date).format(this.$config.date_display) : ''
    },

    formatTimestamp (date) {
      return date ? this.moment.utc(date).local().format(this.$config.timestamp) : ''
    },

    formatDecimal (value) {
      return parseFloat(value).toFixed(2)
    }
  }
  
}